// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

const SecondaryTitle = styled.h3`
  ${({ theme }) => theme.typography.titleMedium};
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing10} 0`};
  color: ${({ theme }) => theme.colors.textPrimary};

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.titleSmall};
  }
`;

export default SecondaryTitle;
